<template>
  <div>
    <div class="md-layout md-alignment-center-center">
      <div class="md-layout-item" style="text-align: center;">
        <template v-if="qr && qr.length > 0">
        <p>あなたのQRコード</p>
        <img :src="qr" alt="QRコード" style="display: block; margin: auto;"/>
        <a :href="url" class="mypage__url-box">{{url}}</a>
        </template>
      </div>
    </div>
    <template v-if="initialized && Object.keys(schedules).length == 0">
      <md-empty-state
        md-icon="date_range"
        md-label="まだ候補日がありません"
        md-description="めし行けそうな日を登録してください。">
      </md-empty-state>
    </template>
    <div class="md-layout md-alignment-top-center" v-if="initialized && Object.keys(schedules).length > 0">
      <div class="md-layout-item md-large-size-50 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
        <md-table>
          <md-table-row>
            <md-table-head>日付</md-table-head>
            <md-table-head>朝めし</md-table-head>
            <md-table-head>昼めし</md-table-head>
            <md-table-head>晩めし</md-table-head>
          </md-table-row>
          <md-table-row v-for="(values, key, index) in schedules" :key='index'>
            <md-table-cell>{{Number(key) | toDateFormat}}</md-table-cell>
            <md-table-cell>{{values['morning']}}</md-table-cell>
            <md-table-cell>{{values['lunch']}}</md-table-cell>
            <md-table-cell>{{values['dinner']}}</md-table-cell>
          </md-table-row>
        </md-table>
      </div>
    </div>
    <div class="md-layout md-alignment-top-center">
      <div class="md-layout-item md-size-100" style="text-align: center;">
        <md-button class='md-raised md-primary' @click='toSchedules'>候補日を追加する</md-button>
      </div>
    </div>
  </div>
</template>

<script>
import firebaseApp from '@/firebaseApp'
import router from '@/router'
import moment from 'moment'
import keySort from '@/utils/keySort'
const db = firebaseApp.firestore()
db.settings({ timestampsInSnapshots: true })
const schedulesRef = db.collection('schedules')
let data = {
  schedules: {},
  url: '',
  qr: '',
  initialized: false
}

export default {
  created () {
    data.initialized = false
    data.userId = firebaseApp.auth().currentUser.uid
    data.url = `${location.origin}/${data.userId}/entry`
    data.qr = `https://api.qrserver.com/v1/create-qr-code/?data=${data.url}&size=100x100&format=png&color=1d417a&bgcolor=f7f6eb`
    data.schedules = {}
    schedulesRef.where('userId', '==', data.userId).get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          if (!data.schedules[doc.data().dateTime]) data.schedules[doc.data().dateTime] = {morning: '', lunch: '', dinner: ''}
          data.schedules[doc.data().dateTime][doc.data().type] = doc.data().reserveUserName ? doc.data().reserveUserName : '○'
        })
        data.schedules = keySort(data.schedules)
        data.initialized = true
      })
      .catch(function (error) {
        console.log('Error getting documents: ', error)
      })
  },
  data () {
    return data
  },
  methods: {
    toSchedules () {
      router.push({name: 'Schedules'})
    }
  },
  filters: {
    toDateFormat: function (value) {
      if (!value) return ''
      return moment(new Date(value)).format('YYYY/MM/DD')
    }
  }
}
</script>

<style lang="sass" scoped>
.mypage__url-box
  display: inline-block
  word-wrap: break-word
  word-break: break-all
  padding: 5px
  border: 1px #eee solid
  margin: 10px 0
</style>



// WEBPACK FOOTER //
// src/components/Mypage.vue